/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 14:27:12
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-08-24 16:42:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelInvoice/InvoiceInformation/index.tsx
 */
import {
  Checkbox,
  Input,
  Radio,
  // Select,
  TextArea,
} from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import { Divider, Form } from 'antd';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import ImageUpload from '../Components/ImageUpload';
import Label from '../Components/Label';
import css from '../css.module.less';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import {
  PhoneNumber,
  AreaCodeInfo,
} from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
//import { Icon } from '@/src/tools/icon';

const InvoiceInformation = ({
  storeData,
  states,
  countries,
  defaultAreaText,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const pageSize = [
    {
      label: getI18n('salesChannelInvoice.invoiceInformation.pageSize1'),
      value: false,
    },
    {
      label: getI18n('salesChannelInvoice.invoiceInformation.pageSize2'),
      value: true,
    },
  ];
  const {
    name: storeName = '',
    entityName = '',
    entityRegistrationNumber = '',
    country = {},
    email = '',
    addressLine = '',
    subdivision = {},
    postCode = '',
  } = storeData || {};

  const statesOptions = states.map((item) => ({
    uuid: item.uuid,
    name: item.name,
  }));
  const options = useSelector(getAreaCodes());

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      title={getI18n(
        'salesChannelInvoice.invoiceInformation.invoiceInformation',
      )}
      subtitle={getI18n(
        'salesChannelInvoice.invoiceInformation.invoiceInformationSubtitle',
      )}>
      <Form.Item name='informationCustomized'>
        <Radio
          className={css.informationCustomized}
          radioList={pageSize}
          disabled={disableEdit}></Radio>
      </Form.Item>
      <Divider></Divider>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.informationCustomized !==
          currentValues.informationCustomized
        }>
        {({ getFieldValue }) => (
          <Fragment>
            <Form.Item
              name={
                getFieldValue('informationCustomized')
                  ? 'titleCustomized'
                  : 'title'
              }
              labelCol={{
                span: 24,
                className: css.invoceTitle,
              }}
              rules={[
                {
                  required: true,
                  message: replaceI18nVariables(
                    getI18n('general.fieldisrequired'),
                    getI18n(
                      'salesChannelInvoice.invoiceInformation.invoiceTitle',
                    ),
                  ),
                },
              ]}
              label={
                <Label
                  title={`${getI18n(
                    'salesChannelInvoice.invoiceInformation.invoiceTitle',
                  )}*`}
                  bottomTitle={getI18n(
                    'salesChannelInvoice.invoiceInformation.invoiceTitleBottom',
                  )}
                />
              }>
              <Input
                disabled={
                  !getFieldValue('informationCustomized') || disableEdit
                }
                size='large'
                className={css.input}
              />
            </Form.Item>
          </Fragment>
        )}
      </Form.Item>
      <Form.Item
        shouldUpdate
        // ={(prevValues, currentValues) =>
        //   prevValues.informationCustomized !==
        //     currentValues.informationCustomized ||
        //   prevValues.phoneEnabledCustomized !==
        //     currentValues.phoneEnabledCustomized ||
        //   prevValues.emailEnabledCustomized !==
        //     currentValues.emailEnabledCustomized ||
        //   prevValues.addressEnabledCustomized !=
        //     currentValues.addressEnabledCustomized
        // }
      >
        {({ getFieldValue }) => {
          const areaCodeInfo = getFieldValue('areaCodeInfo');
          const areaCodeInText =
            get(
              options.find((i) => i.uuid === get(areaCodeInfo, 'uuid')),
              'areaCode',
            ) || '';
          const phone = getFieldValue('phone');
          return (
            <Fragment>
              <Form.Item
                name={
                  getFieldValue('informationCustomized')
                    ? 'logoCustomized'
                    : 'logo'
                }
                label={
                  <Label
                    title={getI18n(
                      'salesChannelInvoice.invoiceInformation.logo',
                    )}
                    bottomTitle={getI18n(
                      'salesChannelInvoice.invoiceInformation.logoBottom',
                    )}
                  />
                }
                labelCol={{
                  span: 24,
                }}>
                <ImageUpload
                  disabled={
                    !getFieldValue('informationCustomized') || disableEdit
                  }></ImageUpload>
              </Form.Item>
              <div className={css.checkboxBoxContain}>
                <div className={css.flexContain}>
                  {/* Store Name */}
                  <Form.Item
                    noStyle
                    name={
                      getFieldValue('informationCustomized')
                        ? 'storeNameEnabledCustomized'
                        : 'storeNameEnabled'
                    }
                    valuePropName='checked'>
                    <Checkbox
                      disabled={
                        !getFieldValue('informationCustomized') || disableEdit
                      }
                      className={css.checkboxBox}>
                      <span className={css.checkTitle}>
                        {' '}
                        {getI18n(
                          'salesChannelInvoice.invoiceInformation.storeName',
                        )}
                      </span>
                      <span>{storeName}</span>
                    </Checkbox>
                  </Form.Item>
                  {/* Entity Name */}
                  <Form.Item
                    noStyle
                    name={
                      getFieldValue('informationCustomized')
                        ? 'entityNameEnabledCustomized'
                        : 'entityNameEnabled'
                    }
                    valuePropName='checked'>
                    <Checkbox
                      disabled={
                        !getFieldValue('informationCustomized') || disableEdit
                      }
                      className={css.checkboxBox}>
                      <span className={css.checkTitle}>
                        {' '}
                        {getI18n(
                          'salesChannelInvoice.invoiceInformation.entityName',
                        )}
                      </span>
                      <span>{entityName}</span>
                    </Checkbox>
                  </Form.Item>

                  {/* Entity Registration Number */}
                  <Form.Item
                    noStyle
                    name={
                      getFieldValue('informationCustomized')
                        ? 'entityRegistrationNumberEnabledCustomized'
                        : 'entityRegistrationNumberEnabled'
                    }
                    valuePropName='checked'>
                    <Checkbox
                      disabled={
                        !getFieldValue('informationCustomized') || disableEdit
                      }
                      className={css.checkboxBox}>
                      <span className={css.checkTitle}>
                        {getI18n(
                          'salesChannelInvoice.invoiceInformation.entityRegistrationNumber',
                        )}
                      </span>
                      <span>{entityRegistrationNumber}</span>
                    </Checkbox>
                  </Form.Item>
                  {/* Payment Information */}
                  <Form.Item
                    noStyle
                    name={
                      getFieldValue('informationCustomized')
                        ? 'paymentEnabledCustomized'
                        : 'paymentEnabled'
                    }
                    valuePropName='checked'>
                    <Checkbox
                      disabled={
                        !getFieldValue('informationCustomized') || disableEdit
                      }
                      className={css.checkboxBox}>
                      <span className={css.checkTitle}>
                        {getI18n(
                          'salesChannelInvoice.invoiceInformation.paymentInformation',
                        )}
                      </span>
                      <span>
                        {getI18n(
                          'salesChannelInvoice.invoiceInformation.paymentInformationDesc',
                        )}
                      </span>
                    </Checkbox>
                  </Form.Item>
                </div>
                <div className={css.flexContain}>
                  {/* pnone */}
                  <Fragment>
                    {getFieldValue('informationCustomized') ? (
                      <div className={css.checkboxAndInput}>
                        <Form.Item
                          noStyle
                          name='phoneEnabledCustomized'
                          valuePropName='checked'>
                          <Checkbox
                            className={css.checkboxBox}
                            disabled={disableEdit}>
                            <span className={css.checkTitle}>
                              {' '}
                              {getI18n(
                                'salesChannelInvoice.invoiceInformation.phone',
                              )}
                            </span>
                          </Checkbox>
                        </Form.Item>
                        {getFieldValue('phoneEnabledCustomized') ? (
                          <div className={css.checkboxInput}>
                            <Form.Item
                              name='areaCodeInfo'
                              className={css.combinationSelect}>
                              <AreaCodeInfo disabled={disableEdit} />
                              {/* <Select
                                size='large'
                                suffixIcon={
                                  <Icon type='icondown' className={css.icon} />
                                }
                                disabled={disableEdit}
                                getPopupContainer={(trigger) => trigger}
                                optionsList={areaCodesOptions}
                                optionLabelProp='label'
                                dropdownClassName={css.dropdown}
                                dropdownRender={(menu) => (
                                  <div>
                                    {defaultAreaText && (
                                      <div className={css.defaultAreaCode}>
                                        {defaultAreaText}
                                      </div>
                                    )}
                                    {defaultAreaText && (
                                      <Divider
                                        className={css.divider}
                                        style={{ margin: '4px 0' }}
                                      />
                                    )}
                                    {menu}
                                  </div>
                                )}
                              /> */}
                            </Form.Item>
                            <Form.Item name='phone' style={{ flex: 1 }}>
                              <PhoneNumber
                                className={css.phoneInput}
                                disabled={disableEdit}
                              />
                            </Form.Item>
                          </div>
                        ) : (
                          <span className={css.subText}>
                            +{areaCodeInText} {phone}
                          </span>
                        )}
                        {/* </Form.Item> */}
                      </div>
                    ) : (
                      <Form.Item
                        noStyle
                        name='phoneEnabled'
                        valuePropName='checked'>
                        <Checkbox disabled={true} className={css.checkboxBox}>
                          <span className={css.checkTitle}>
                            {getI18n(
                              'salesChannelInvoice.invoiceInformation.phone',
                            )}
                          </span>
                          <span>
                            +{areaCodeInText} {phone}
                          </span>
                        </Checkbox>
                      </Form.Item>
                    )}
                  </Fragment>
                  {/* Email */}
                  <Fragment>
                    {getFieldValue('informationCustomized') ? (
                      <div className={css.checkboxAndInput}>
                        <Form.Item
                          noStyle
                          name='emailEnabledCustomized'
                          valuePropName='checked'>
                          <Checkbox
                            className={css.checkboxBox}
                            disabled={disableEdit}>
                            <span className={css.checkTitle}>
                              {getI18n(
                                'salesChannelInvoice.invoiceInformation.email',
                              )}
                            </span>
                          </Checkbox>
                        </Form.Item>
                        {getFieldValue('emailEnabledCustomized') ? (
                          <Form.Item
                            className={css.checkboxInput}
                            name='email'
                            rules={[
                              { type: 'email', message: 'Invalid format' },
                            ]}>
                            <Input size='large' disabled={disableEdit} />
                          </Form.Item>
                        ) : (
                          <span className={css.subText}>{email || '-'}</span>
                        )}
                      </div>
                    ) : (
                      <Form.Item
                        noStyle
                        name='emailEnabled'
                        valuePropName='checked'>
                        <Checkbox disabled={true} className={css.checkboxBox}>
                          <span className={css.checkTitle}>
                            {getI18n(
                              'salesChannelInvoice.invoiceInformation.email',
                            )}
                          </span>
                          <span>{email || '-'}</span>
                        </Checkbox>
                      </Form.Item>
                    )}
                  </Fragment>
                  {/* Address */}
                  <Fragment>
                    {getFieldValue('informationCustomized') ? (
                      <div className={css.checkboxAndInput}>
                        <Form.Item
                          className={css.checkboxInput}
                          name='email'
                          rules={[
                            {
                              type: 'email',
                              message: getI18n('general.invalidformat'),
                            },
                          ]}>
                          <Input size='large' disabled={disableEdit} />
                        </Form.Item>
                        {getFieldValue('addressEnabledCustomized') ? (
                          <Fragment>
                            <Row
                              containerClassName={css.addressLine}
                              elements={[
                                {
                                  child: (
                                    <Form.Item
                                      name='addressLine'
                                      className={css.addressLineItem}>
                                      <TextArea
                                        size='large'
                                        autoSize={{ minRows: 1, maxRows: 2 }}
                                        disabled={disableEdit}
                                      />
                                    </Form.Item>
                                  ),
                                },
                              ]}
                            />
                            <Row
                              containerClassName={css.addressLine}
                              elements={[
                                {
                                  child: (
                                    <Form.Item
                                      label={
                                        <Label
                                          title={
                                            <Label
                                              title={getI18n(
                                                'general.countryRegion',
                                              )}
                                            />
                                          }
                                        />
                                      }
                                      labelCol={{
                                        span: 24,
                                      }}>
                                      <div>{(country || {}).name}</div>
                                    </Form.Item>
                                  ),
                                },
                                {
                                  child: (
                                    <Form.Item
                                      name='subdivision'
                                      label={
                                        <Label
                                          title={`${getI18n(
                                            'salesChannelInvoice.invoiceInformation.stateProvinceDistrict',
                                          )}*`}
                                        />
                                      }
                                      rules={[
                                        {
                                          required: true,
                                          message: replaceI18nVariables(
                                            getI18n('general.fieldisrequired'),
                                            getI18n(
                                              'salesChannelInvoice.invoiceInformation.stateProvinceDistrict',
                                            ),
                                          ),
                                        },
                                      ]}
                                      labelCol={{
                                        span: 24,
                                      }}>
                                      <SelectObjectAsValue
                                        objectAsValue
                                        size='large'
                                        getPopupContainer={(trigger) => trigger}
                                        valueKey='uuid'
                                        labelKey='name'
                                        options={statesOptions}
                                        disabled={disableEdit}
                                      />
                                    </Form.Item>
                                  ),
                                },
                                {
                                  child: (
                                    <Form.Item
                                      name='postCode'
                                      label={
                                        <Label
                                          title={getI18n(
                                            'salesChannelInvoice.invoiceInformation.postcodeZip',
                                          )}
                                        />
                                      }
                                      labelCol={{
                                        span: 24,
                                      }}>
                                      <Input
                                        size='large'
                                        disabled={disableEdit}
                                      />
                                    </Form.Item>
                                  ),
                                },
                              ]}
                            />
                          </Fragment>
                        ) : (
                          <span
                            className={`${css.subText} ${css.subTextAddress}`}>
                            {addressLine} <br />
                            {country.name || {}} {(subdivision || {}).name}{' '}
                            {postCode}
                          </span>
                        )}
                      </div>
                    ) : (
                      <Form.Item
                        noStyle
                        name='addressEnabled'
                        valuePropName='checked'>
                        <Checkbox disabled={true} className={css.checkboxBox}>
                          <span className={css.checkTitle}>
                            {getI18n('general.address')}
                          </span>
                          <span
                            className={`${css.subText} ${css.subTextAddress}`}>
                            {addressLine} <br />
                            {country.name || {}} {(subdivision || {}).name}{' '}
                            {postCode}
                          </span>
                        </Checkbox>
                      </Form.Item>
                    )}
                  </Fragment>
                </div>
              </div>
            </Fragment>
          );
        }}
      </Form.Item>
    </SectionWrapper>
  );
};
export default InvoiceInformation;
